module.exports = __webpack_public_path__ + "img/news_01.6a5dd89d.jpg";